import { render, staticRenderFns } from "./information-info.vue?vue&type=template&id=36e9d978&scoped=true&"
import script from "./information-info.vue?vue&type=script&lang=js&"
export * from "./information-info.vue?vue&type=script&lang=js&"
import style0 from "./information-info.vue?vue&type=style&index=0&id=36e9d978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9d978",
  null
  
)

export default component.exports